export default __webpack_public_path__ + "static/media/DamasoNo8.f50e821e.jpg";